<template>
	<div v-if="context">
		<nk-wrapper
			v-for="(verfahren, verfahrenIndex) in sortedVerfahren"
			:key="verfahrenIndex"
			spacing="md"
		>
			<section v-if="verfahren">
				<nk-title
					v-if="verfahren.letter && sortedVerfahren.length > 1"
					:id="`title-${titleId}`"
					:aria-label="`Alle Verfahren mit dem Buchstabe ${verfahren.letter}`"
					size="lg"
					tag="h1"
					no-margin
				>
					{{ verfahren.letter }}
				</nk-title>
				<nk-nav :aria-labelledby="`title-${titleId}`">
					<nk-nav-item
						v-for="(item, itemIndex) in verfahren.children"
						:key="itemIndex"
						:link="item.detailURL"
					>
						{{ item.titel }}
					</nk-nav-item>
				</nk-nav>
			</section>
		</nk-wrapper>
	</div>
</template>

<script>
import {computed} from 'vue';
import {groupBy, map} from 'lodash-es';
import TemplatesDefault from '../../mixins/templates-default';
import {useCMS, useSEO} from '#nk/composables/cms';
import {useId} from '#imports';

export default {
	name: 'NkTemplateWegweiserVerfahren',

	mixins: [TemplatesDefault],

	setup(ctx) {
		const page = useCMS();

		const sortedVerfahren = computed(() => {
			const group = groupBy(ctx.context, o => o.titel[0].toUpperCase());
			return map(group, (value, key) => ({letter: key, children: value}));
		});

		useSEO({
			title: ctx.context.seo?.title || ctx.context.titel,
			description: ctx.context.seo?.description || page.value.description,
		});

		const titleId = useId();

		return {
			sortedVerfahren,
			titleId,
		};
	},
};
</script>
